import { ApiError } from './client';

/**
 * admin-api mutation failures return a JSON body describing why (`{ message }`
 * or `{ error }` depending on the route); apiClient wraps the raw response
 * text as the ApiError message, so it's parsed back out here rather than
 * swallowed as a generic failure.
 */
export function extractErrorMessage(error: unknown, fallback = 'Request failed.'): string {
  if (error instanceof ApiError) {
    try {
      const body = JSON.parse(error.message) as { message?: string; error?: string };
      return body.message ?? body.error ?? error.message;
    } catch {
      return error.message;
    }
  }
  return error instanceof Error ? error.message : fallback;
}
